<template>
    <v-app>
        <v-layout column align-center>
            <!--Welcoming message at the top of the page-->
            <v-card class="mb-2" :width=1000>
                <v-card-title class="title">
                    Welcome to the directory search!
                </v-card-title>
                <v-flex>
                    <search-popup />
                </v-flex>
            </v-card>
            <!--Visual aspect of the search-->
            <v-card :width=2000 class="ml-2 mr-2">
                <v-card-title class="justify-center">
                    <!--You can change and add buttons from here-->
                    <v-text-field v-model="searchInput" @keyup.enter="search" label="Name" single-line clearable />
                    <v-select v-model="selectedType" :items="typeSelect" placeholder="Type" />

                    <v-btn @click="search()" x-large height="50px">Press to search</v-btn>
                </v-card-title>

                <v-layout>
                    <!--Side filter-->
                    <side-filter ref="sideFilter" @apply-filter="sideFilters" @clear-all-filters="undoFilters"></side-filter>

                    <v-flex>
                        <!--This handles the button of the search tab-->
                        <v-data-table @click:row="handleClick" :headers="peopleHeaders" :items="searchedPeople"
                            :items-per-page="10" class="elevation-1" single-select :must-sort="true" sort-by="lastname"
                            :loading="peopleLoading" loading-text="Loading... Please Wait" />
                    </v-flex>
                </v-layout>
            </v-card>
        </v-layout>

        <!--Displaying each of the entries for this search tab-->
<v-dialog v-model="peopleDialog" max-width="800">
    <v-card outlined class="printable-content">
        <!-- Add the printable-content class to the v-card -->
        <v-card-title class="headline">{{ this.dialogData['firstname'] + " " + this.dialogData['lastname'] 
            }}</v-card-title>

                <v-spacer></v-spacer>
                <v-card-text>
                    <template v-if="this.dialogData.age">
                        <strong>Age: {{ this.dialogData['age'] }}</strong>
                        <v-spacer></v-spacer>
                    </template>
                    <template v-if="this.dialogData.fate">
                        <strong>Fate: {{ this.dialogData['fate'] }}</strong>
                        <v-spacer></v-spacer>
                    </template>
                    <template v-if="this.dialogData.state">
                        <strong>State: {{ this.dialogData['state'] }}</strong>
                        <v-spacer></v-spacer>
                    </template>
                    <template v-if="this.dialogData.company">
                        <strong>Company: {{ dialogData['company'] }}</strong>
                        <v-spacer></v-spacer>
                    </template>
                    <template v-if="this.dialogData.regiment">
                        <strong>Regiment: {{ this.dialogData['regiment'] }}</strong>
                        <v-spacer></v-spacer>
                    </template>
                    <template v-if="this.dialogData.rank">
                        <strong>Rank: {{ this.dialogData['rank'] }}</strong>
                        <v-spacer></v-spacer>
                    </template>
                    <template v-if="this.dialogData.prison">
                        <strong>Prison: {{ this.dialogData['prison'] }}</strong>
                        <v-spacer></v-spacer>
                    </template>
                </v-card-text>
                <!-- Add carousel to display images -->
                <v-container fluid class="flex-grow-1 flex-shrink-0">
                    <v-row align="left" justify="left">
                        <v-carousel v-if="items.length > 0" :show-arrows="hover" hide-delimiter-background
                            min-width="100px" max-width="100%" class="flex-grow-2 flex-shrink-0" hide-delimiters
                            align="center" height="100%">
                            <!-- this loops through however many images there are-if there even are any. -->
                            <!-- the handleImageCLick() opens a new window with the image enlarged -->
                            <v-carousel-item v-for="(item, index) in items" :key="index"
                                @click="handleImageClick(item.src)">
                                <div class="image-container">
                                    <img :src="item.src" alt="Image" height="410vw" />
                                </div>
                            </v-carousel-item>
                            <v-carousel-item>
                                <div class="sources">
                                    <p>Sources: {{ this.dialogData['comments'] }}</p>
                                </div>
                            </v-carousel-item>
                        </v-carousel>
                        <div v-else class="sources">
                            <p>Sources: {{ this.dialogData['comments'] }}</p>
                        </div>
                    </v-row>
                </v-container>
                <v-card-actions>
                    <!-- non-printable class sets aside things that should not show up in the print window -->
                      <v-btn class="non-printable" text @click="peopleDialog = false">Close</v-btn>
                    <v-divider></v-divider>
                    <v-divider inset></v-divider>
                    <v-btn class="non-printable" text @click="display()">Print</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-app>
</template>


<style>
/* changes the cursor to a pointing hand if it hovers over some stuff */
.elevation-1>.v-data-table__wrapper>table>tbody>tr:hover {
    cursor: pointer;
}
/* adds padding to the sources */
.sources {
    padding: 10px;
}

</style>

<script>
import firebase from 'firebase';
import SearchPopup from "./SearchPopup";
import SideFilter from "./SideFilter";

export default {
    components: { SearchPopup, SideFilter },

    created() {
        this.fetchDataFromFirebase();
    },

    methods: {
        undoFilters() {
    // Reset searchedPeople to originalSearchResults
    this.searchedPeople = [...this.originalSearchResults];
  },
        sideFilters(selectedOptions) {
            const companyMappings = {
                'Field and Staff': 'F & S (Field and Staff)',
                // Add other mappings as needed for different UI representations
            };
            const stateMappings = {
                'Virginia': 'Virginia (Louden County Virginia Rangers)',
                // Add other mappings as needed for different UI representations
            };

            const rankMappings = {
                'Blksm': 'Blksmith',
                'Music': 'Musician',
                'Prin. Music': 'Princ. Musician',
                'Tmstr': 'Teamster',
                // Add other mappings as needed for different UI representations
            };


            // Extract selected company and fate options from the SideFilter component
            const selectedCompanies = selectedOptions.company.map(uiCompany => companyMappings[uiCompany] || uiCompany);
            const selectedFates = selectedOptions.fate;
            const selectedStates = selectedOptions.state.map(uiState => stateMappings[uiState] || uiState);
            const selectedRegiments = selectedOptions.regiment;
            const selectedPrisons = selectedOptions.prison;
            const selectedRanks = selectedOptions.rank.map(uiRank => rankMappings[uiRank] || uiRank);

            // Ensure there are original search results available
            if (this.originalSearchResults.length > 0) {
                if (selectedCompanies.length > 0 || selectedFates.length > 0 || selectedStates.length > 0 || selectedRegiments.length > 0 || selectedPrisons.length > 0 || selectedRanks.length > 0) {
                    // Filter the original search results based on selected company and fate options
                    this.searchedPeople = this.originalSearchResults.filter(person => {
                        // Check if the person's company matches any selected company or no companies selected
                        const matchesCompany = selectedCompanies.length === 0 || selectedCompanies.includes(person.company);

                        // Check if the person's fate matches any selected fate or no fates selected
                        const matchesFate = selectedFates.length === 0 || selectedFates.includes(person.fate);

                        const matchesState = selectedStates.length === 0 || selectedStates.includes(person.state);

                        const matchesRegiment = selectedRegiments.length === 0 || selectedRegiments.includes(person.regiment);

                        const matchesPrison = selectedPrisons.length === 0 || selectedPrisons.includes(person.prison);

                        const matchesRank = selectedRanks.length === 0 || selectedRanks.includes(person.rank);

                        // Return true if the person matches both company and fate filters
                        return matchesCompany && matchesFate && matchesState && matchesRegiment && matchesPrison && matchesRank;
                    });
                } else {
                    // If no filters selected, display original search results
                    this.searchedPeople = [...this.originalSearchResults];
                }
            }
        },
        async fetchDataFromFirebase() {
            const db = firebase.firestore();

            try {
                // Collection options from firebase
                const collectionNames = ['people', 'passenger', 'crew', 'ohio'];

                for (const collectionName of collectionNames) {

                    const querySnapshot = await db.collection(collectionName).where("isDeleted", "==", false).get();

                    // Map over the documents and push the data into the people array
                    querySnapshot.forEach(doc => {
                        const data = doc.data();
                        this.people.push({
                            searchType: String(collectionName),
                            id: String(doc.id),
                            firstname: String(data.firstname),
                            lastname: String(data.lastname),
                            state: data.state,
                            age: data.age,
                            company: data.company,
                            prison: data.prison,
                            fate: data.fate,
                            rank: data.rank,
                            regiment: data.regiment,
                            comments: data.comments,
                            imageOneLink: data.imageOneLink,
                            imageTwoLink: data.imageTwoLink
                            // add other fields in future...
                        });
                    });
                }
                // print all people
                // console.log("The people: ", this.people)
                this.search();

            } catch (error) {
                console.error('Error fetching documents: ', error);
                // Handle errors
            }
        },
        async search() {
            this.peopleLoading = true;
            this.searchedPeople = []; // Clear previous search results
            const searchLower = this.searchInput;

            // Filter and search within the local data based on the selected type
            this.searchedPeople = this.people.filter(person => {

                if (!this.searchInput && !this.selectedType) {
                    // If both searchInput and selectedType are empty, return true for all people
                    return true;
                }
                // if there is no text in the searchInput, only filter by selectedType
                else if (!this.searchInput) {
                    if (this.selectedType === 'All People') {
                        return true 
                    }
                    // Compares the name of selected type to the what category each person is in, if they match, then return true to show that person
                    else if (this.selectedType === 'Paroled Union Prisoner' && person.searchType === 'people') {
                        return true;
                    } else if (this.selectedType === 'Passenger' && person.searchType === 'passenger') {
                        return true;
                    } else if (this.selectedType === 'Crew' && person.searchType === 'crew') {
                        return true;
                    } else if (this.selectedType === 'Guard Unit - 58th Ohio Infantry' && person.searchType === 'ohio') {
                        return true;
                    } else {
                        return false
                    }
                }
                // otherwise there is text in the searchInput
                else {
                    // Set variables for firstname, lastname, and full name (all lowercased)
                    const firstName = person.firstname ? person.firstname.toLowerCase() : '';
                    const lastName = person.lastname ? person.lastname.toLowerCase() : '';
                    const fullName = (firstName + " " + lastName);

                    // checks if the selectedType matches the category each person is in and if the seachInput is a part of of the person's firstName, lastName, or fullName. If so return true to show that person
                    if (this.selectedType === 'All People' && (fullName.includes(searchLower.toLowerCase()) || firstName.includes(searchLower.toLowerCase()) || lastName.includes(searchLower.toLowerCase()))) {
                        return true;
                    }
                    else if (this.selectedType === 'Paroled Union Prisoner' && person.searchType === 'people' && (fullName.includes(searchLower.toLowerCase()) || firstName.includes(searchLower.toLowerCase()) || lastName.includes(searchLower.toLowerCase()))) {
                        return true;
                    } else if (this.selectedType === 'Passenger' && person.searchType === 'passenger' && (fullName.includes(searchLower.toLowerCase()) || firstName.includes(searchLower.toLowerCase()) || lastName.includes(searchLower.toLowerCase()))) {
                        return true;
                    } else if (this.selectedType === 'Crew' && person.searchType === 'crew' && (fullName.includes(searchLower.toLowerCase()) || firstName.includes(searchLower.toLowerCase()) || lastName.includes(searchLower.toLowerCase()))) {
                        return true;
                    } else if (this.selectedType === 'Guard Unit - 58th Ohio Infantry' && person.searchType === 'ohio' && (fullName.includes(searchLower.toLowerCase()) || firstName.includes(searchLower.toLowerCase()) || lastName.includes(searchLower.toLowerCase()))) {
                        return true;
                    } else if (!this.selectedType && (fullName.includes(searchLower.toLowerCase()) || firstName.includes(searchLower.toLowerCase()) || lastName.includes(searchLower.toLowerCase()))) {
                        return true;
                    } else {
                        return false
                    }
                }

            });

            this.originalSearchResults = [...this.searchedPeople];

            // clear the filters from previous search
            this.$refs.sideFilter.resetFilters();

            // prints the filtered people
            //console.log("Filtered People: ", this.searchedPeople)

            this.peopleLoading = false;
        },

        // for clicking on the person to view
        async handleClick(event) {
            this.peopleDialog = true;
            this.dialogData = event;
            this.imageOneLink = "";
            this.imageTwoLink = "";

            if (this.dialogData['imageOneLink'] != null && this.dialogData['imageOneLink'].length > 0) {
                this.imageOneLink = this.dialogData['imageOneLink'];
            }

            if (this.dialogData['imageTwoLink'] != null && this.dialogData['imageTwoLink'].length > 0) {
                this.imageTwoLink = this.dialogData['imageTwoLink'];
            }

            console.log("Image One Link:", this.imageOneLink);
            console.log("Image Two Link:", this.imageTwoLink);

            // Check if the links' lengths are greater than zero before populating the items array
            this.items = [];

            if (this.imageOneLink.length > 0) {
                this.items.push({ src: this.imageOneLink });
            }


            // Separate condition for imageTwoLink
            if (this.imageTwoLink.length > 0) {
                this.items.push({ src: this.imageTwoLink });
            }
            // If both links are empty, items will remain an empty array

            // Update selectedImage with the URL of the clicked image
            this.selectedImage = event.src;
            // Open the image dialog
            this.imageDialog = true;

        },

display() {
   
  // Open new window
  const printWindow = window.open('', '_blank');

  // Write printable content to new window
    //    goes through and checks whether the person has any of these and then displays it if they do
  printWindow.document.write(`
      <html>
      <head>
          <title>${this.dialogData.firstname} ${this.dialogData.lastname}</title>
          <style>
        //   style for the new print window
              @media print {
                .non-printable {
                display: none !important;
                  }
              }
              body {
                padding: 30px;
              }
              p {
                font-family: Helvetica, Arial, sans-serif;
                font-size: 1.2rem;
              }
              h2 {
                font-family: Helvetica, Arial, sans-serif;
                font-size: 1.5rem;
              }
              .print-button {
                background-color: white;
                border: none;
                color: #38466E;
                 padding: 15px 15px;
                text-align: center;
                text-decoration: none;
                font-family: Helvetica, Arial, sans-serif;
                font-size: 18px;
                border-radius: 6px;
                border: 2px solid #38466E;
              }
              img {
                display: block;
                margin-left: auto;
                margin-right: auto;
            }
               .print-button:hover {
                   background-color:  #e7e7e7;
                    cursor: pointer;
            }
              .sources {
                  font-family: Helvetica, Arial, sans-serif;
                  font-weight: light;
                  font-size: 14px;
                  margin-top: 10px;
                  margin-bottom: 20px;

              }
              
          </style>
      </head>
      <body>
           <h2 align="center">${this.dialogData.firstname} ${this.dialogData.lastname}</h2>
        ${this.dialogData.age ? `<p>Age: ${this.dialogData.age}</p>` : ''}
        ${this.dialogData.fate ? `<p>Fate: ${this.dialogData.fate}</p>` : ''}
        ${this.dialogData.state ? `<p>State: ${this.dialogData.state}</p>` : ''}
        ${this.dialogData.company ? `<p>Company: ${this.dialogData.company}</p>` : ''}
        ${this.dialogData.regiment ? `<p>Regiment: ${this.dialogData.regiment}</p>` : ''}
        ${this.dialogData.prison ? `<p>Prison: ${this.dialogData.prison}</p>` : ''}
        ${this.dialogData.rank ? `<p>Rank: ${this.dialogData.rank}</p>` : ''}
            
      </body>
      </html>
  `);
  

// Add items if there are any to printable content
 // this adds images if they have any
const itemsContent = `
    <div style="display: flex; flex-wrap: wrap;">
        ${this.items.map(item => `
            <div style="flex: 1; padding: 10px;">
                <img src="${item.src}" alt="Additional Image" style="height: 410px; max-width: 100%;">
            </div>
        `).join('')}
    </div>
`;
printWindow.document.write(itemsContent);

  // Add sources to printable content and the print button
  const sourcesContent = `
      <div>
           <div class="sources">Sources: ${this.dialogData['comments']}</div>
           <div><div/>
       
           <button class="print-button non-printable" onclick="window.print()">PRINT</button>
      </div>
  `;
  printWindow.document.write(sourcesContent);
  
  // Add event listener in the new window
  printWindow.addEventListener('DOMContentLoaded', () => {
      // Perform actions when the new window's content is loaded
      console.log('New window content loaded');

      // Execute scripts in the new window
      const newScript = printWindow.document.createElement('script');
      newScript.textContent = `
          // JavaScript code to execute in the new window. the print function
          function printWindowContent() {
             window.print();
            }
            // log to check the window is working
          console.log('Script executed in the new window');
      `;
      printWindow.document.body.appendChild(newScript);
  });

  // Close window after printing
  printWindow.onload = function() {
      printWindow.print();
      printWindow.close();
}
},


// this is the function that opens a new window with the image being larger
        handleImageClick(imageSrc) {
            // Set the selectedImage to the URL of the clicked image
            this.selectedImage = imageSrc;

            // Open a popup window
            const popupWindow = window.open('', '_blank', 'width=800,height=800');

            // Load the image in the popup window
            popupWindow.document.write(`
        <style>
            img {
                transform: scale(${this.scale});
                max-width: 100%;
                max-height: 100%;
            }
        </style>
        <img src="${imageSrc}" style="min-height: 800px; transform: scale(${this.scale}); max-width: 100%; max-height: 100%;">
    `);
        },

    },
    props: {
        navButtons: {
            type: Array
        },
        primaryColor: {
            type: String
        },
        secondaryColor: {
            type: String
        },
        thirdColor: {
            type: String
        },
        buttonColor: {
            type: String
        }
    },

    data: () => ({
        imageOneLink: "",
        imageTwoLink: "",
        items: [],

        firstname: "",
        lastname: "",
        state: "",
        company: "",
        prison: "",
        fate: "",
        regiment: "",
        comments: "",
        age: "",
        rank: "",

        imageDialog: false,
        selectedImage: '', // New data property to store the URL of the clicked image

        searchInput: "",

        peopleLoading: false,
        searchedPeople: [],
        people: [],
        peopleDialog: false,

        companySelected: true,
        dialogData: {},
        headers: [],

        // options for the dropdown
        typeSelect: [
            'Paroled Union Prisoner',
            'Passenger',
            'Crew',
            'Guard Unit - 58th Ohio Infantry',
            'All People'
        ],

        // headers shown for the search results
        peopleHeaders: [
            {
                text: 'Fate',
                align: 'start',
                sortable: true,
                value: 'fate'
            },
            {
                text: 'First Name',
                align: 'start',
                sortable: true,
                value: 'firstname'
            },
            {
                text: 'Last Name',
                align: 'start',
                sortable: true,
                value: 'lastname'
            },

            {
                text: 'Age',
                align: 'start',
                sortable: true,
                value: 'age'
            }
        ],

        data() {
            return {
                people: [], // Local variable to store the fetched data
                originalSearchResults: [],
                items: [],
                scale: 1, // Initial zoom scale
            };
        }
    })
}
</script>
